import { render, staticRenderFns } from "./OffersWinEdit.vue?vue&type=template&id=7340d1b6&scoped=true&"
import script from "./OffersWinEdit.vue?vue&type=script&lang=js&"
export * from "./OffersWinEdit.vue?vue&type=script&lang=js&"
import style0 from "./OffersWinEdit.vue?vue&type=style&index=0&id=7340d1b6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7340d1b6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/emotivi-v2-extranet/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7340d1b6')) {
      api.createRecord('7340d1b6', component.options)
    } else {
      api.reload('7340d1b6', component.options)
    }
    module.hot.accept("./OffersWinEdit.vue?vue&type=template&id=7340d1b6&scoped=true&", function () {
      api.rerender('7340d1b6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/OffersWinEdit.vue"
export default component.exports